export default __webpack_public_path__ + "static/media/layout-1 (4).660b7bfa.jpg";